/*
 * @Description:
 * @Author: Mark
 * @Date: 2021-08-16 11:19:54
 * @LastEditors: mengli
 * @LastEditTime: 2022-05-17 15:04:34
 * @FilePath: /ecom-client/src/vue-config/directive.ts
 */
import Vue, { DirectiveOptions, DirectiveFunction } from 'vue'
import { parseQuery } from '../utils/mUtil'
import { default as format } from '@/utils/format'

const directives: Record<string, DirectiveFunction | DirectiveOptions> = {
  rshow: {
    inserted(el, binding) {
      if (!binding.value) return
      try {
        const { dslData } = binding.value

        let reportData
        if (dslData) {
          reportData = {
            show_content: format(binding.value),
          }
          //dsl模块上报
        } else {
          reportData = binding.value
        }

        window.ecShow(el, Object.assign({}, getLobParamToReport(), reportData))
      } catch (e) {}
    },
  },
}

function getLobParamToReport() {
  const win = window as any
  const { goodReportData = {}, deviceInfo = {} } = win
  const attrs = goodReportData.attrs || {}
  return {
    $url: location.href,
    goods_id: goodReportData.goods_id && goodReportData.goods_id.toString(),
    // goods_num: attrs.goods_num,
    // shop_price: attrs.price || '',
    // spec1: attrs.spec1,
    // spec2: attrs.spec2,
    // store_id: goodReportData.store_id && goodReportData.store_id.toString(),
    ref_page_name: parseQuery().refPageName || '',
    $event_type: 'track',
    $project: 'mgtv-ec',
    $network_type: deviceInfo?.network_type,
  }
}

export default directives
